import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as DraftActions from 'web-app/react/entities/drafts/actions';

import * as Actions from './actions';

const DraftManagerState = Record({
    draftInFlight: false,
    updatingDraft: false,
    updateFailed: false,
    creating: false,
    draftIsDirty: false,
    clearing: false,
    posting: false,
    showDraftSelector: false,
    showObservationForm: false,
    observationVariant: null,
    currentDraftId: null,
});

const draftManagerReducer = handleActions(
    {
        [Actions.reset.type]: () => new DraftManagerState(),
        [Actions.showDraftSelector.type]: (state, {payload}) =>
            state.merge({
                showDraftSelector: payload.show,
            }),
        [Actions.showObservationForm.type]: (state, {payload}) =>
            state.merge({
                showObservationForm: payload.show,
                observationVariant: null,
                currentDraftId: null,
            }),
        [Actions.clearDraft.type]: state =>
            state.merge({
                posting: false,
                clearing: true,
                showDraftSelector: false,
            }),
        [Actions.clearDraftSuccess.type]: (state, {payload}) =>
            state.merge({
                showObservationForm: payload.showObservationForm,
                draftIsDirty: false,
                clearing: false,
                updateFailed: false,
                currentDraftId: null,
                observationVariant: null,
            }),
        [Actions.clearDraftFailed.type]: state =>
            state.merge({
                clearing: false,
                updateFailed: true,
            }),
        [Actions.selectDraft.type]: state =>
            state.merge({
                posting: false,
                draftIsDirty: false,
                updateFailed: false,
                updatingDraft: true,
                showDraftSelector: false,
            }),
        [Actions.selectDraftSuccess.type]: (state, {payload}) =>
            state.merge({
                updatingDraft: false,
                showObservationForm: payload.showObservationForm,
                observationVariant: payload.variant,
                currentDraftId: payload.draftId,
            }),
        [DraftActions.create.type]: state =>
            state.merge({
                draftInFlight: true,
                updateFailed: false,
                creating: true,
            }),
        [DraftActions.createFailed.type]: state =>
            state.merge({
                draftInFlight: false,
                updateFailed: true,
                creating: false,
            }),
        [DraftActions.createSuccess.type]: (state, {payload}) =>
            state.merge({
                draftInFlight: false,
                draftIsDirty: false,
                creating: false,
                observationVariant: payload.draft.variant,
                currentDraftId: payload.draft.postId,
            }),
        [Actions.update.type]: state =>
            state.merge({
                draftInFlight: true,
                updateFailed: false,
            }),
        [Actions.send.type]: state =>
            state.merge({
                posting: true,
            }),
        [Actions.sendFailed.type]: state =>
            state.merge({
                posting: false,
            }),
        [Actions.sendAborted.type]: state =>
            state.merge({
                posting: false,
            }),
        [Actions.updatePost.type]: state =>
            state.merge({
                posting: true,
            }),
        [Actions.updatePostSuccess.type]: state =>
            state.merge({
                posting: false,
            }),
        [Actions.updatePostFailed.type]: state =>
            state.merge({
                posting: false,
            }),
        [DraftActions.sendSuccess.type]: state =>
            state.merge({
                posting: false,
                draftIsDirty: false,
                updateFailed: false,
                observationVariant: null,
                currentDraftId: null,
            }),
        [DraftActions.updateSuccess.type]: state =>
            state.merge({
                draftInFlight: false,
                draftIsDirty: false,
                updateFailed: false,
            }),
        [Actions.createOrUpdateFailed.type]: state =>
            state.merge({
                draftInFlight: false,
                creating: false,
                updateFailed: true,
            }),
        [DraftActions.removeSuccess.type]: (state, {payload}) =>
            state.merge({
                updateFailed: false,
                draftIsDirty: false,
                observationVariant: state.currentDraftId === payload.draftId ? null : state.observationVariant,
                currentDraftId: state.currentDraftId === payload.draftId ? null : state.currentDraftId,
            }),
        [DraftActions.removeAborted.type]: state =>
            state.merge({
                showDraftSelector: true,
            }),
        [Actions.createOrUpdate.type]: state =>
            state.merge({
                draftIsDirty: true,
            }),
    },
    new DraftManagerState(),
);

export default draftManagerReducer;
